import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

const Img = (props) => {
  const { alt } = props;
  const [src, setSrc] = React.useState("");
  const [errored, setErrored] = React.useState(false);

  React.useEffect(() => {
    setSrc(props.src);
  }, [setSrc]);

  const onError = () => {
    if (!errored) {
      setSrc("https://via.placeholder.com/10x10.png?text=placeholder");
      setErrored(true);
    }
  };
  return (
    <React.Fragment>
      {errored ? (
        <CircularProgress style={{ width: "1em", height: "1em" }} />
      ) : (
        <img {...props} src={src} alt={alt} onError={() => onError()} />
      )}
    </React.Fragment>
  );
};

export default Img;
